<h1 class="page-title">Sorozatok</h1>

<div *ngIf="!series">
  <span class="fa fa-spinner fa-spin"></span>
  <span class="sr-only">Betöltés</span>
</div>

<div class="div-table" *ngIf="series">
  <div class="div-table-body">
    <div class="row py-3 py-sm-2" *ngFor="let s of series">
      <div class="col-md-8">
          <span (click)="loadLectures(s)"
                class="clickable"
          >
            {{s.title}}
            <span style="white-space:nowrap">({{s.when}})</span>
          </span>
      </div>
      <div class="col-md-4 mt-2 mt-md-0">
        <button class="btn btn-sm btn-success"
                type="button"
                (click)="loadLectures(s)"
        ><i class="fa fa-arrow-right"></i> Mutasd!
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="series && auth.hasRole('av')" class="mt-3">
  <a [routerLink]="['/admin/felvetelek/sorozatok/uj']"
     class="btn btn-outline-primary"
  >
    <span class="fa fa-plus"></span> Új
  </a>
</div>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/series/series.component.html